/**
 * Format a UTC ISO timestamp as Riyadh local time `HH:MM YYYY-MM-DD`.
 *
 * The backend stores all timestamps as timezone-aware UTC. Rendering them
 * with `.slice(0,16)` (as several pages historically did) leaks the raw
 * UTC value to the user and makes clocked-in times, request submissions,
 * push events, etc. look 3 hours behind reality. This helper pins the
 * display to `Asia/Riyadh` regardless of the viewer's own browser
 * timezone (e.g. HR reviewing while abroad).
 */
export function fmtKsa(iso) {
  if (!iso) return '-';
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return String(iso).slice(0, 16).replace('T', ' ');
    const fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Riyadh',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false,
    });
    const parts = fmt.formatToParts(d).reduce((a, p) => ({ ...a, [p.type]: p.value }), {});
    return `${parts.hour}:${parts.minute} ${parts.year}-${parts.month}-${parts.day}`;
  } catch {
    return String(iso);
  }
}

/**
 * Return today's date in KSA as `YYYY-MM-DD`. Used to cap `<input type="date">`
 * `max` attributes so admins cannot accidentally fetch attendance for a
 * "future" day (which produces empty/misleading tables).
 */
export function todayKsa() {
  const now = new Date();
  const fmt = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Riyadh',
    year: 'numeric', month: '2-digit', day: '2-digit',
  });
  // en-CA returns YYYY-MM-DD directly.
  return fmt.format(now);
}
